import axios from 'axios'
import QS from 'qs'
import store from '../store' // 引入 vuex
import router from '../router' // 引入 vuex
import { MessageBox } from 'element-ui'
import '../assets/icon/iconfont/iconfont.css'
import JSEncrypt from 'jsencrypt' // 传输数据加密

axios.defaults.baseURL = 'http://lvmeng.greenglga.com/api.php/portal/' // 正式
axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.timeout = 20 * 1000 // 设置请求超时

// 添加请求拦截器，在请求头中加token
axios.interceptors.request.use(
  config => {
    try {
      const data = JSON.parse(localStorage.getItem('user'))
      if (data.authorization) {
        config.headers.common['XX-Token'] = data.authorization
        return config
      }
    } catch (e) {}
    return config
  },
  error => {
    return Promise.reject(error)
  })
// 添加响应拦截器
axios.interceptors.response.use(function (response) {
  const text = response.data.msg
  switch (response.data.code) {
    case 101: // 未登录
      MessageBox.alert('您未登录账号', '温馨提示', {
        type: 'error',
        confirmButtonText: '去登录',
        showClose: false,
        callback: () => {
          const url = window.location.href
          store.commit('other/updateOldUrl', url) // 修改vuex中的地址记录
          router.push({ name: 'Login' }) // 跳转登陆页
        }
      })
      break
    case 102: // 登录过期
      MessageBox.alert('您的账号已在其他地方登陆,请您确认账号安全！', '温馨提示', {
        type: 'error',
        confirmButtonText: '去登录',
        showClose: false,
        callback: () => {
          localStorage.removeItem('user')
          const getUrl = window.location.host
          window.location.href = 'http://' + getUrl + '/login'
        }
      })
      break
    case 201: // 内容被删除
      MessageBox.alert('您查找的内容不存在！', '温馨提示', {
        type: 'error',
        confirmButtonText: '确定',
        showClose: false,
        callback: () => {
          window.close()
        }
      })
      break
    case 202:
      MessageBox.alert('您的操作过于频繁，请稍后再试！', '温馨提示', {
        type: 'error',
        confirmButtonText: '确定',
        showClose: false,
        callback: () => {
        }
      })
      break
    case 404:
      if (response.data.data !== 'im') {
        MessageBox.alert(text, '温馨提示', {
          type: 'error',
          confirmButtonText: '确定',
          showClose: false,
          callback: () => {
          }
        })
      }
      break
    case 405:
      MessageBox.alert('您的操作频率过高，请稍后再试！', '温馨提示', {
        type: 'error',
        confirmButtonText: '确定',
        showClose: false,
        callback: () => {
        }
      })
      break
  }
  return response
}, function (error) {
  if (error.message === '取消上传') {
    MessageBox.alert('取消文件上传成功', '温馨提示', {
      type: 'success',
      confirmButtonText: '确定',
      showClose: false
    })
  } else if (error.message.indexOf('timeout') !== -1) {
    MessageBox.alert('服务器请求超时，请检查网络链接是否正确！', '温馨提示', {
      type: 'error',
      confirmButtonText: '确定',
      showClose: false
    })
    return
  } else {
    // MessageBox.alert('网络连接错误！', '温馨提示', {
    //   type: 'error',
    //   confirmButtonText: '确定',
    //   showClose: false,
    //   callback: () => {
    //     // window.history.go(-1)
    //     // location.reload()
    //   }
    // })
  }
  throw error
})

// 数据加密
// str 就是需要加密的参数
const getRSA = (str) => {
  // RSA 公钥
  const pubKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDocdc9nWBS/GUhxfUv8An+4USW6mbq0S4pZpfIwfv/KxSeZznbZH32R0VNKWghiSQN6pVQ8B+0/lgeYy2DUK8MgwS7+j/NvlWf2HbVlMeQAdM3fTvQlcC0eMoZJLQ9YPnPnjew8jY0v/xrp6f1YEBy2xTx6oxMf4vH/qXt/oacFwIDAQAB'
  const encryptStr = new JSEncrypt()
  encryptStr.setPublicKey(pubKey)
  const data = encryptStr.encrypt(str.toString())
  return data
}

// 短信发送
const send = number => {
  return axios({
    method: 'POST',
    url: 'Login/send',
    data: QS.stringify(number)
  })
}

// 注册
const register = info => {
  info.password = getRSA(info.password)
  info.repeat_password = getRSA(info.repeat_password)
  return axios({
    method: 'POST',
    url: 'Login/register',
    data: QS.stringify(info)
  })
}

// 登录
const login = info => {
  if (info.password !== undefined) {
    info.password = getRSA(info.password)
  }
  return axios({
    method: 'POST',
    url: 'Login/login',
    data: QS.stringify(info)
  })
}

// 退出登录
const loginOut = () => {
  return axios({
    method: 'POST',
    url: 'User/loginOut'
  })
}

// 微信登录
const webWeChatLogin = info => {
  return axios({
    method: 'POST',
    url: 'Login/webWeChatLogin',
    data: QS.stringify(info)
  })
}

// 微博登录
const sinaLogin = info => {
  return axios({
    method: 'POST',
    url: 'Login/sinaLogin',
    data: QS.stringify(info)
  })
}

// 手机号与第三方绑定
const bindTripartiteTel = info => {
  return axios({
    method: 'POST',
    url: 'Login/bindTripartiteTel',
    data: QS.stringify(info)
  })
}

// 账号密码与第三方绑定
const bindPlatformNumber = info => {
  if (info.password !== undefined) {
    info.password = getRSA(info.password)
  }
  return axios({
    method: 'POST',
    url: 'Login/bindPlatformNumber',
    data: QS.stringify(info)
  })
}

// 快速注册与第三方绑定
const fastRegister = info => {
  return axios({
    method: 'POST',
    url: 'Login/fastRegister',
    data: QS.stringify(info)
  })
}
/* -------------------------------- 右侧快捷操作栏 --------------------------------------------- */
// 判断是否已开通播主认证
const isAnchor = data => {
  return axios({
    method: 'POST',
    url: 'Room/isAnchor',
    data: QS.stringify(data)
  })
}
/* -------------------------------- 发布 --------------------------------------------- */
// 发布板块获取
const getModel = (data) => {
  return axios({
    method: 'POST',
    url: 'Total/getCommunityNavList',
    data: QS.stringify(data)
  })
}
// 发布板块标签获取
const getLabel = () => {
  return axios({
    method: 'POST',
    url: 'Articles/getTag'
  })
}

// 发布板块标签研究院
const MyResearchList = () => {
  return axios({
    method: 'POST',
    url: 'Articles/MyResearchList'
  })
}

// 发起直播图片上传
const upload = (data) => {
  return axios({
    method: 'POST',
    url: 'Image/imageRoomUpload',
    data: data
  })
}

// 直播申请提交
const liveSub = data => {
  return axios({
    method: 'POST',
    url: 'Room/roomExamine',
    data: QS.stringify(data)
  })
}

// 发布文章文件上传
const fileUpload = (data, cancelToken) => {
  return axios({
    method: 'POST',
    url: 'Image/fileUpload',
    data: data,
    cancelToken: cancelToken
  })
}

// 发布文章文件删除 PS:所有文件的删除
const delFile = (data) => {
  return axios({
    method: 'POST',
    url: 'Articles/deleteArticleFile',
    data: QS.stringify(data)
  })
}

// 发布文章保存
const articlesPreserved = data => {
  return axios({
    method: 'POST',
    url: 'Articles/setArticleDrafts',
    data: QS.stringify(data)
  })
}

// 发布文章提交
const articlesSub = data => {
  return axios({
    method: 'POST',
    url: 'Articles/save',
    data: QS.stringify(data)
  })
}

// 获取云点播签名
const getVideoSig = () => {
  return axios({
    method: 'POST',
    url: 'Video/getSig'
  })
}

// 上传视频记录
const addVideoRecord = (data) => {
  return axios({
    method: 'POST',
    url: 'Video/adVideoRecord',
    data: QS.stringify(data)
  })
}

// 删除视频
const delVideoRecord = (data) => {
  return axios({
    method: 'POST',
    url: 'Video/delVideoRecord',
    data: QS.stringify(data)
  })
}

// 视频上传
const videoUpload = (data, progress) => {
  return axios({
    method: 'POST',
    url: 'Image/videoUpload',
    data: data,
    onUploadProgress: progress
  })
}

// 发布视频提交
const videoSub = (data) => {
  return axios({
    method: 'POST',
    url: 'Video/AMyVideo',
    data: QS.stringify(data)
  })
}

/* -------------------------------- 首页 --------------------------------------------- */
// 首页
const homePage = data => {
  return axios({
    method: 'POST',
    url: 'Index/homePage',
    data: QS.stringify(data)
  })
}

// 首页 - 联盟生态切换
const homeEcology = data => {
  return axios({
    method: 'POST',
    url: 'Index/getAllianceEcology',
    data: QS.stringify(data)
  })
}

// 首页 - 研究院生态
const homeResearch = data => {
  return axios({
    method: 'POST',
    url: 'Index/getResearch',
    data: QS.stringify(data)
  })
}
/* -------------------------------- 社区生态 --------------------------------------------- */
// 社区生态首页内容获取
const communityIndex = () => {
  return axios({
    method: 'POST',
    url: 'glga/communityIndex'
  })
}

/* -------------------------------- 专家学者会客厅/专业精英工作/行业精英工作室 --------------------------------------------- */
// 最近直播列表获取
const livelist = data => {
  return axios({
    method: 'POST',
    url: 'Room/getLiveList',
    data: QS.stringify(data)
  })
}

// 精彩回顾列表获取
const videolist = data => {
  return axios({
    method: 'POST',
    url: 'Video/getPlayBackVideoList',
    data: QS.stringify(data)
  })
}

// 我的直播详情获取
const liveMyDetail = data => {
  return axios({
    method: 'POST',
    url: 'Room/videoLive',
    data: QS.stringify(data)
  })
}

// 直播详情获取
const liveDetail = data => {
  return axios({
    method: 'POST',
    url: 'Room/getLiveDetails',
    data: QS.stringify(data)
  })
}

// 直播预告报名
const signUp = data => {
  return axios({
    method: 'POST',
    url: 'Room/addMyCollection',
    data: QS.stringify(data)
  })
}

// 获取用户名
const userName = data => {
  return axios({
    method: 'POST',
    url: 'User/getUserName',
    data: QS.stringify(data)
  })
}

// 获取推流状态
const getFlowStatsu = data => {
  return axios({
    method: 'POST',
    url: 'Room/getFlowStatsu',
    data: QS.stringify(data)
  })
}

// 视频回放
const videoDetails = data => {
  return axios({
    method: 'POST',
    url: 'Video/videoDetails',
    data: QS.stringify(data)
  })
}

/* -------------------------------- 社区交流 --------------------------------------------- */
// 社区交流列表
const communityMembersList = data => {
  return axios({
    method: 'POST',
    url: 'Articles/communityMembers',
    data: QS.stringify(data)
  })
}

// 社区交流右侧推荐列表
const communityRecommendMembersList = data => {
  return axios({
    method: 'POST',
    url: 'Articles/publicRecommend',
    data: QS.stringify(data)
  })
}

// 社区交流详情
const communityMemberDetails = data => {
  return axios({
    method: 'POST',
    url: 'Articles/communityMemberDetails',
    data: QS.stringify(data)
  })
}

/* -------------------------------- 活跃用户 --------------------------------------------- */
const activeUserList = data => {
  return axios({
    method: 'POST',
    url: 'Account/activeList',
    data: QS.stringify(data)
  })
}

/* -------------------------------- 专家观点 --------------------------------------------- */
// 专家观点-专家观点列表
const expertList = data => {
  return axios({
    method: 'POST',
    url: 'Articles/expertList',
    data: QS.stringify(data)
  })
}

// 专家观点-专家观点详情
const expertDetail = data => {
  return axios({
    method: 'POST',
    url: 'Articles/expertDetails',
    data: QS.stringify(data)
  })
}
/* -------------------------------- 视频 --------------------------------------------- */
// 视频-视频列表
const communityVideoList = data => {
  return axios({
    method: 'POST',
    url: 'Video/communityEcologyVideoList',
    data: QS.stringify(data)
  })
}
/* ---------------------------------- 圈子 ----------------------------------------------- */
// 圈子-加入圈子
const applyBoard = data => {
  return axios({
    method: 'POST',
    url: 'Board/applyBoard',
    data: QS.stringify(data)
  })
}
// 圈子-退出圈子
const retreatBoard = data => {
  return axios({
    method: 'POST',
    url: 'Board/retreatBoard',
    data: QS.stringify(data)
  })
}

// 圈子-解散圈子
const dissolutionBoard = data => {
  return axios({
    method: 'POST',
    url: 'Board/dissolutionBoard',
    data: QS.stringify(data)
  })
}

// 圈子-创建圈子
const createBoard = data => {
  return axios({
    method: 'POST',
    url: 'Board/createBoard',
    data: QS.stringify(data)
  })
}

// 圈子-修改圈子
const eoardEditSub = data => {
  return axios({
    method: 'POST',
    url: 'Board/eoardEditSub',
    data: QS.stringify(data)
  })
}

// 圈子列表-用户信息
const boardGetMyInfo = data => {
  return axios({
    method: 'POST',
    url: 'Board/getMyInformation',
    data: QS.stringify(data)
  })
}

// 圈子列表-我的圈子列表
const boardIndex = data => {
  return axios({
    method: 'POST',
    url: 'Board/boardIndex',
    data: QS.stringify(data)
  })
}

// 圈子列表-我加入的圈子列表
const myJoinBoardList = data => {
  return axios({
    method: 'POST',
    url: 'Board/myJoinBoardList',
    data: QS.stringify(data)
  })
}

// 圈子列表-热度排序圈子列表
const getHotBoardList = data => {
  return axios({
    method: 'POST',
    url: 'Board/getHotBoardList',
    data: QS.stringify(data)
  })
}

// 圈子列表-时间排序圈子列表
const getNewestBoardList = data => {
  return axios({
    method: 'POST',
    url: 'Board/getNewestBoardList',
    data: QS.stringify(data)
  })
}

// 圈子帖子列表-获取圈子信息及成员
const getBoardDetails = data => {
  return axios({
    method: 'POST',
    url: 'Board/getBoardDetails',
    data: QS.stringify(data)
  })
}

// 圈子帖子列表-发布上传图片
const boardImageUpload = data => {
  return axios({
    method: 'POST',
    url: 'Image/boardImageUpload',
    data: data
  })
}

// 圈子帖子列表-帖子发布
const boardDynamicCreate = data => {
  return axios({
    method: 'POST',
    url: 'Board/boardDynamicCreate',
    data: QS.stringify(data)
  })
}

// 圈子帖子列表-获取圈子帖子列表
const boardPostList = data => {
  return axios({
    method: 'POST',
    url: 'Board/boardPostList',
    data: QS.stringify(data)
  })
}

// 圈子帖子列表-帖子列表点赞
const boardDoLike = data => {
  return axios({
    method: 'POST',
    url: 'Board/doLike',
    data: QS.stringify(data)
  })
}

// 圈子帖子列表-帖子列表取消点赞
const boardCancelLike = data => {
  return axios({
    method: 'POST',
    url: 'Board/cancelLike',
    data: QS.stringify(data)
  })
}

// 圈子帖子-举报
const BoardReport = data => {
  return axios({
    method: 'POST',
    url: 'Board/report',
    data: QS.stringify(data)
  })
}

// 圈子帖子-删除
const boardDynamicDel = data => {
  return axios({
    method: 'POST',
    url: 'Board/boardDynamicDel',
    data: QS.stringify(data)
  })
}

// 圈子帖子详情-获取帖子详情信息
const getBoardDynamicDetails = data => {
  return axios({
    method: 'POST',
    url: 'Board/getBoardDynamicDetails',
    data: QS.stringify(data)
  })
}

// 圈子帖子详情-一级评论
const boardDynamicMes = data => {
  return axios({
    method: 'POST',
    url: 'Board/boardDynamicMes',
    data: QS.stringify(data)
  })
}
// 圈子帖子详情-二级评论
const boardleReplyMes = data => {
  return axios({
    method: 'POST',
    url: 'Board/boardleReplyMes',
    data: QS.stringify(data)
  })
}
// 圈子帖子详情-二级评论列表
const boardTowMesList = data => {
  return axios({
    method: 'POST',
    url: 'Board/boardTowMesList',
    data: QS.stringify(data)
  })
}
// 圈子帖子详情-评论排序
const boardMesSort = data => {
  return axios({
    method: 'POST',
    url: 'Board/boardMesSort',
    data: QS.stringify(data)
  })
}
// 圈子帖子详情-评论点赞
const BoardMesDoLike = data => {
  return axios({
    method: 'POST',
    url: 'Board/mesDoLike',
    data: QS.stringify(data)
  })
}
// 圈子帖子详情-评论取消点赞
const BoardMesCanceLike = data => {
  return axios({
    method: 'POST',
    url: 'Board/mesCanceLike',
    data: QS.stringify(data)
  })
}

// 圈子帖子详情-评论屏蔽
const BoardShieldMess = data => {
  return axios({
    method: 'POST',
    url: 'Board/shieldMes',
    data: QS.stringify(data)
  })
}

// 圈子帖子详情-评论删除
const BoardDelBoardMes = data => {
  return axios({
    method: 'POST',
    url: 'Board/delBoardMes',
    data: QS.stringify(data)
  })
}

// 圈子帖子详情-评论举报
const BoardReportMes = data => {
  return axios({
    method: 'POST',
    url: 'Board/reportMes',
    data: QS.stringify(data)
  })
}

/* -------------------------------- 联盟生态 --------------------------------------------- */

// 导航页
const getUnionList = () => {
  return axios({
    method: 'POST',
    url: 'Union/unionList'
  })
}

// 加入联盟
const applyJoinUnion = data => {
  return axios({
    method: 'POST',
    url: 'Union/applyJoinUnion',
    data: QS.stringify(data)
  })
}

// 联盟简介
const unionFramework = data => {
  return axios({
    method: 'POST',
    url: 'Union/unionFramework',
    data: QS.stringify(data)
  })
}

// 联盟首页
const getUnionIndex = data => {
  return axios({
    method: 'POST',
    url: 'Union/index',
    data: QS.stringify(data)
  })
}

// 推荐
const plateRecommendation = data => {
  return axios({
    method: 'POST',
    url: 'Hotspot/plateRecommendation',
    data: QS.stringify(data)
  })
}

// 动态
const unionDynamic = data => {
  return axios({
    method: 'POST',
    url: 'Union/unionDynamic',
    data: QS.stringify(data)
  })
}

// 研讨沙龙 -  列表
const getDiscussLiveList = data => {
  return axios({
    method: 'POST',
    url: 'Room/getDiscussLiveList',
    data: QS.stringify(data)
  })
}
// 培训 - 我的培训列表
const myTrainList = data => {
  return axios({
    method: 'POST',
    url: 'Video/myTrainList',
    data: QS.stringify(data)
  })
}

// 培训 - 培训列表
const unionTrainList = data => {
  return axios({
    method: 'POST',
    url: 'Union/unionTrain',
    data: QS.stringify(data)
  })
}

// 培训 - 我的培训详情
const getTrainDetails = data => {
  return axios({
    method: 'POST',
    url: 'Video/getTrainDetails',
    data: QS.stringify(data)
  })
}

// 人脉 - 我的人脉列表
const getMyContacts = data => {
  return axios({
    method: 'POST',
    url: 'Contacts/getMyContacts',
    data: QS.stringify(data)
  })
}

// 人脉 - 人脉列表
const contactsList = data => {
  return axios({
    method: 'POST',
    url: 'Contacts/getRecommendContactsList',
    data: QS.stringify(data)
  })
}

// 培训 - 项目路演 - 项目路演列表 - 论坛列表 - 基金会列表 - 公益项目列表
const totalList = data => {
  return axios({
    method: 'POST',
    url: 'Articles/totalList',
    data: QS.stringify(data)
  })
}

// 项目路演 - 项目路演推荐列表 - 论坛推荐列表 - 基金会推荐列表 - 公益项目推荐列表
const totalRecommendList = data => {
  return axios({
    method: 'POST',
    url: 'Articles/totalRecommendList',
    data: QS.stringify(data)
  })
}

// 项目路演 - 项目路演详情
const roadshowDetails = data => {
  return axios({
    method: 'POST',
    url: 'Articles/projectRoadshowDetails',
    data: QS.stringify(data)
  })
}

// 项目路演 - 论坛详情
const forumDetails = data => {
  return axios({
    method: 'POST',
    url: 'Articles/forumDetails',
    data: QS.stringify(data)
  })
}

// 项目路演 - 基金会详情
const fundDetails = data => {
  return axios({
    method: 'POST',
    url: 'Articles/foundationsDetails',
    data: QS.stringify(data)
  })
}

// 项目路演 - 公益项目详情
const welfareDetails = data => {
  return axios({
    method: 'POST',
    url: 'Articles/foundationsDetails',
    data: QS.stringify(data)
  })
}

/* -------------------------------- 研究院生态 --------------------------------------------- */

// 研究院导航页 - 研究院列表
const getResearchList = () => {
  return axios({
    method: 'POST',
    url: 'Research/getResearchList'
  })
}

// 加入研究院
const joinResearch = data => {
  return axios({
    method: 'POST',
    url: 'Research/applyJoinResearch',
    data: QS.stringify(data)
  })
}

// 研究院生态 - 研究院简介
const getResearchFramework = data => {
  return axios({
    method: 'POST',
    url: 'Research/getResearchFramework',
    data: QS.stringify(data)
  })
}

// 研究院生态 - 首页
const getResearchIndex = data => {
  return axios({
    method: 'POST',
    url: 'Research/index',
    data: QS.stringify(data)
  })
}

// 研究院 - 研究院动态
const getIndexResearchDynamicList = data => {
  return axios({
    method: 'POST',
    url: 'Research/getIndexResearchDynamicList',
    data: QS.stringify(data)
  })
}

// 研究院 - 研究院成员列表
const getWebResearchUserList = data => {
  return axios({
    method: 'POST',
    url: 'Research/getWebResearchUserList',
    data: QS.stringify(data)
  })
}

// 研究院 - 研究院组织架构成员
const getResearchFrameworkUser = data => {
  return axios({
    method: 'POST',
    url: 'Research/getResearchFrameworkUser',
    data: QS.stringify(data)
  })
}

// 研究院 - 研究院国际交流/学术交流/项目合作列表
const researchTotalList = data => {
  return axios({
    method: 'POST',
    url: 'Research/totalList',
    data: QS.stringify(data)
  })
}

// 研究院 - 研究院国际交流/学术交流/项目合作列表
const researchTotalRecommendList = data => {
  return axios({
    method: 'POST',
    url: 'Research/totalRecommendList',
    data: QS.stringify(data)
  })
}

// 研究成果 - 行业手册 - 报告下载 列表
const getResearchFindingsList = data => {
  return axios({
    method: 'POST',
    url: 'Research/getResearchFindingsList',
    data: QS.stringify(data)
  })
}

// 研究成果 - 行业手册 - 报告下载 推荐
const reportRecommend = data => {
  return axios({
    method: 'POST',
    url: 'Research/reportRecommend',
    data: QS.stringify(data)
  })
}

// 研究成果 - 行业手册 - 报告下载 详情
const reportDetail = data => {
  return axios({
    method: 'POST',
    url: 'Research/getResearchDetails',
    data: QS.stringify(data)
  })
}

// 下载量监控
const addDownload = data => {
  return axios({
    method: 'POST',
    url: 'Research/addDownload',
    data: QS.stringify(data)
  })
}

// 出版物 列表
const getBookList = data => {
  return axios({
    method: 'POST',
    url: 'Research/bookList',
    data: QS.stringify(data)
  })
}

// 出版物 详情
const getBookDetails = data => {
  return axios({
    method: 'POST',
    url: 'Research/getBookDetails',
    data: QS.stringify(data)
  })
}

// 国际交流 - 学术交流 - 项目合作 详情
const getListDetails = data => {
  return axios({
    method: 'POST',
    url: 'Research/getListDetails',
    data: QS.stringify(data)
  })
}

// 研究学院首页 - 专家学者
const contactInformation = data => {
  return axios({
    method: 'POST',
    url: 'Research/contactInformation',
    data: QS.stringify(data)
  })
}

/* -------------------------------- 个人中心 --------------------------------------------- */
// 个人中心 - 个人信息
const getMyDetails = () => {
  return axios({
    method: 'POST',
    url: 'User/getMyDetails'
  })
}
// 个人中心 - 我的动态
const getMyDynamic = data => {
  return axios({
    method: 'POST',
    url: 'User/getMyDynamic',
    data: QS.stringify(data)
  })
}
// 个人中心 - 关于我的
const getAboutMeList = data => {
  return axios({
    method: 'POST',
    url: 'User/getAboutMeList',
    data: QS.stringify(data)
  })
}

// 个人中心-直播管理列表
const liveAdminList = data => {
  return axios({
    method: 'POST',
    url: 'Room/getMyRoomList',
    data: QS.stringify(data)
  })
}

// 个人中心-直播管理列表-我要开播
const liveAdminOpenLive = data => {
  return axios({
    method: 'POST',
    url: 'Room/editLiveStatus',
    data: QS.stringify(data)
  })
}

// 个人中心-直播管理列表-我要开播研讨沙龙
const getDiscussPushList = data => {
  return axios({
    method: 'POST',
    url: 'Room/getDiscussPushList',
    data: QS.stringify(data)
  })
}

// 个人中心-直播管理列表-关闭直播
const downcast = data => {
  return axios({
    method: 'POST',
    url: 'Room/downcast',
    data: QS.stringify(data)
  })
}

// 个人中心-直播管理列表-关闭直播回放显示
const editVideoExhibition = data => {
  return axios({
    method: 'POST',
    url: 'User/editVideoExhibition',
    data: QS.stringify(data)
  })
}

// 个人中心-直播管理列表-直播编辑信息获取
const getEditLive = data => {
  return axios({
    method: 'POST',
    url: 'Room/editLive',
    data: QS.stringify(data)
  })
}

// 个人中心-直播管理列表-直播编辑信息提交
const subEditLive = data => {
  return axios({
    method: 'POST',
    url: 'Room/editLiveSub',
    data: QS.stringify(data)
  })
}

// 个人中心-文章管理列表
const articleAdminList = data => {
  return axios({
    method: 'POST',
    url: 'Articles/myArticleList',
    data: QS.stringify(data)
  })
}

// 个人中心-文章管理编辑获取信息
const articleEdit = data => {
  return axios({
    method: 'POST',
    type: 'hidden',
    url: 'Articles/articleEdit',
    data: QS.stringify(data)
  })
}

// 个人中心-文章管理编辑提交
const articleEditSub = data => {
  return axios({
    method: 'POST',
    type: 'hidden',
    url: 'Articles/articleEditSub',
    data: QS.stringify(data)
  })
}

// 个人中心-文章管理删除
const articleDel = data => {
  return axios({
    method: 'POST',
    type: 'hidden',
    url: 'Articles/deleteArticle',
    data: QS.stringify(data)
  })
}

// 个人中心-视频管理列表
const videoAdminList = data => {
  return axios({
    method: 'POST',
    url: 'Video/getlMyVideoList',
    data: QS.stringify(data)
  })
}

// 个人中心-视频申诉
const appealVideos = data => {
  return axios({
    method: 'POST',
    url: 'User/appealVideos',
    data: QS.stringify(data)
  })
}

// 个人中心-视频详情
const videoDetail = data => {
  return axios({
    method: 'POST',
    url: 'Video/getVideodetailed',
    data: QS.stringify(data)
  })
}

// 个人中心-草稿箱管理列表
const draftAdminList = data => {
  return axios({
    method: 'POST',
    url: 'Articles/TDraftsList',
    data: QS.stringify(data)
  })
}

// 个人中心-草稿详情
const draftDetail = data => {
  return axios({
    method: 'POST',
    url: 'Articles/getArticleDrafts',
    data: QS.stringify(data)
  })
}

// 个人中心-草稿箱管理删除草稿
const draftDel = data => {
  return axios({
    method: 'POST',
    url: 'Articles/deleteDrafts',
    data: QS.stringify(data)
  })
}

// 个人中心-我的关注
const getMyfollowList = data => {
  return axios({
    method: 'POST',
    url: 'User/getMyfollowList',
    data: QS.stringify(data)
  })
}

// 个人中心-我的粉丝
const getMyFansList = data => {
  return axios({
    method: 'POST',
    url: 'User/getMyFansList',
    data: QS.stringify(data)
  })
}

// 个人中心-我的收藏
const getMyCollectionList = data => {
  return axios({
    method: 'POST',
    url: 'User/getMyCollectionList',
    data: QS.stringify(data)
  })
}

// 个人中心-我的评论
const getMyMesList = data => {
  return axios({
    method: 'POST',
    url: 'User/getMyMesList',
    data: QS.stringify(data)
  })
}

// 个人中心-获取个人认证信息
const getAuthenticationLog = data => {
  return axios({
    method: 'POST',
    url: 'User/getAuthenticationLog',
    data: QS.stringify(data)
  })
}

// 个人中心-认证提交接口
const userRealNameAuthentication = data => {
  return axios({
    method: 'POST',
    url: 'User/userRealNameAuthentication',
    data: QS.stringify(data)
  })
}

// 个人中心-个人信息修改
const editPersonalData = data => {
  return axios({
    method: 'POST',
    url: 'User/editMyDataSub',
    data: QS.stringify(data)
  })
}

// 个人中心-账号管理-获取帐号绑定信息
const getUserBindInfo = data => {
  return axios({
    method: 'POST',
    url: 'User/getUserBindInfo',
    data: QS.stringify(data)
  })
}

// 个人中心-账号管理-账号修改
const addAccountName = data => {
  return axios({
    method: 'POST',
    url: 'User/addAccountName',
    data: QS.stringify(data)
  })
}

// 个人中心-账号管理-密码修改
const editPassword = data => {
  data.password = getRSA(data.password)
  data.repeat_password = getRSA(data.repeat_password)
  return axios({
    method: 'POST',
    url: 'User/editPassword',
    data: QS.stringify(data)
  })
}

// 个人中心-账号管理-手机绑定修改
const editBindTel = data => {
  return axios({
    method: 'POST',
    url: 'User/editBindTel ',
    data: QS.stringify(data)
  })
}

// 个人中心-账号管理-获取邮箱验证码
const sendEmail = data => {
  return axios({
    method: 'POST',
    url: 'Mail/sendEmail ',
    data: QS.stringify(data)
  })
}

// 个人中心-账号管理-邮箱修改
const checkingEmail = data => {
  return axios({
    method: 'POST',
    url: 'Mail/checking',
    data: QS.stringify(data)
  })
}

// 个人中心-账号管理-获取第三方账号信息
const tripartiteInfo = data => {
  return axios({
    method: 'POST',
    url: 'User/tripartiteInfo',
    data: QS.stringify(data)
  })
}

// 个人中心-账号管理-绑定第三方
const bingTripartite = data => {
  return axios({
    method: 'POST',
    url: 'User/bingTripartite',
    data: QS.stringify(data)
  })
}

// 个人中心-账号管理-解绑第三方
const unbundlingTripartite = data => {
  return axios({
    method: 'POST',
    url: 'User/unbundlingTripartite',
    data: QS.stringify(data)
  })
}

/* -------------------------------- 个人中心展示 --------------------------------------------- */

// 个人中心展示 - 个人信息与其它
const getUserDetails = data => {
  return axios({
    method: 'POST',
    url: 'User/getUserDetails',
    data: QS.stringify(data)
  })
}

// 个人中心展示 - 个人发表
const getBloggerDetails = data => {
  return axios({
    method: 'POST',
    url: 'User/getBloggerDetails',
    data: QS.stringify(data)
  })
}

/* -------------------------------- 即时通讯 --------------------------------------------- */
// 我的关注用户列表
const getMyFollowMessage = data => {
  return axios({
    method: 'POST',
    url: 'Chat/getMyFollowMessage',
    data: QS.stringify(data)
  })
}

// 设置已读
const editReadMsg = data => {
  return axios({
    method: 'POST',
    url: 'Chat/editReadMsg',
    data: QS.stringify(data)
  })
}

// 获取我的消息列表
const getMyToMsgList = data => {
  return axios({
    method: 'POST',
    url: 'Chat/getMyToMsgList',
    data: QS.stringify(data)
  })
}

/* -------------------------------- 小铃铛 --------------------------------------------- */
// 小铃铛未读数
const getInformationReadCount = data => {
  return axios({
    method: 'POST',
    url: 'User/getInformationReadCount',
    data: QS.stringify(data)
  })
}

// 小铃铛列表
const getInformationReadList = data => {
  return axios({
    method: 'POST',
    url: 'User/getInformationReadList',
    data: QS.stringify(data)
  })
}

// 小铃铛列表清除未读
const clearInformationRead = data => {
  return axios({
    method: 'POST',
    url: 'User/clearInformationRead',
    data: QS.stringify(data)
  })
}

/* -------------------------------- 通用功能 --------------------------------------------- */
// 热搜列表
const hotList = data => {
  return axios({
    method: 'POST',
    url: 'glga/hotsearch',
    data: QS.stringify(data)
  })
}

// 推荐列表
const recommendList = data => {
  return axios({
    method: 'POST',
    url: 'glga/wholeRecommend',
    data: QS.stringify(data)
  })
}

// 是否有即使通讯消息
const unreadMessage = () => {
  return axios({
    method: 'POST',
    url: 'User/getMes'
  })
}

// 用户关注
const addFollow = data => {
  return axios({
    method: 'POST',
    url: 'User/care',
    data: QS.stringify(data)
  })
}

// 用户取消关注
const cancelFollow = data => {
  return axios({
    method: 'POST',
    url: 'User/cancelCare',
    data: QS.stringify(data)
  })
}

// // 点赞功能
const doLike = data => {
  return axios({
    method: 'POST',
    url: 'Total/doLike',
    data: QS.stringify(data)
  })
}
// 取消点赞功能
const cancelLike = data => {
  return axios({
    method: 'POST',
    url: 'Total/cancelLike',
    data: QS.stringify(data)
  })
}
// 收藏功能
const doFavorite = data => {
  return axios({
    method: 'POST',
    url: 'Total/doFavorite',
    data: QS.stringify(data)
  })
}
// 取消收藏功能
const cancelFavorite = data => {
  return axios({
    method: 'POST',
    url: 'Total/cancelFavorite',
    data: QS.stringify(data)
  })
}

// 分享次数记录
const addShare = data => {
  return axios({
    method: 'POST',
    url: 'Total/addShare',
    data: QS.stringify(data)
  })
}

// 一级评论提交
const oneMes = data => {
  return axios({
    method: 'POST',
    url: 'Total/OneMes',
    data: QS.stringify(data)
  })
}
// 二级评论提交
const replyMes = data => {
  return axios({
    method: 'POST',
    url: 'Total/ReplyMes',
    data: QS.stringify(data)
  })
}
// 评论点赞
const mesDoLike = data => {
  return axios({
    method: 'POST',
    url: 'Total/mesDoLike',
    data: QS.stringify(data)
  })
}
// 评论取消点赞
const mesCanceLike = data => {
  return axios({
    method: 'POST',
    url: 'Total/mesCanceLike',
    data: QS.stringify(data)
  })
}
// 评论举报
const reportMes = data => {
  return axios({
    method: 'POST',
    url: 'Total/reportMes',
    data: QS.stringify(data)
  })
}
// 评论屏蔽
const shieldMes = data => {
  return axios({
    method: 'POST',
    url: 'Total/shieldMes',
    data: QS.stringify(data)
  })
}
// 评论删除
const delArticleMes = data => {
  return axios({
    method: 'POST',
    url: 'Total/delArticleMes',
    data: QS.stringify(data)
  })
}
// 文章评论加载更多
const articleSort = data => {
  return axios({
    method: 'POST',
    url: 'Total/articleSort',
    data: QS.stringify(data)
  })
}
// 文章二级评论加载更多回复
const articleTowMesList = data => {
  return axios({
    method: 'POST',
    url: 'Total/TowMesList',
    data: QS.stringify(data)
  })
}

// 视频文章举报接口
const report = data => {
  return axios({
    method: 'POST',
    url: 'Total/report',
    data: QS.stringify(data)
  })
}

// 评论敏感词过滤
const sensitive = data => {
  return axios({
    method: 'POST',
    url: 'Articles/sensitive',
    data: QS.stringify(data)
  })
}

// 问题反馈
const addFeedback = data => {
  return axios({
    method: 'POST',
    url: 'Total/addFeedback',
    data: QS.stringify(data)
  })
}

/* ----------------------------------- 全局搜索 ----------------------------------------------- */
const search = data => {
  return axios({
    method: 'POST',
    url: 'Total/search',
    data: QS.stringify(data)
  })
}

/* ----------------------------------- 手机H5页面 ----------------------------------------------- */
// 文章详情
const totalDetailsMobile = data => {
  return axios({
    method: 'POST',
    url: 'MobileH5/totalDetails',
    data: QS.stringify(data)
  })
}

// 手机H5热门推荐
const labelRecommendMobile = data => {
  return axios({
    method: 'POST',
    url: 'MobileH5/labelRecommend',
    data: QS.stringify(data)
  })
}

// 输出接口api
const myapi = {
  send: send, // 获取短信
  register: register, // 注册
  login: login, // 登录
  loginOut: loginOut, // 退出登录
  webWeChatLogin: webWeChatLogin, // 微信登录
  sinaLogin: sinaLogin, // 微博登录
  bindTripartiteTel: bindTripartiteTel, // 手机号与第三方绑定
  bindPlatformNumber: bindPlatformNumber, // 账号与第三方绑定
  fastRegister: fastRegister, // 快速注册与第三方绑定
  // 右侧快捷操作栏
  isAnchor: isAnchor, // 快捷操作验证是否已开通播主认证
  // 发布
  getModel: getModel, // 获取板块
  getLabel: getLabel, // 获取标签
  MyResearchList: MyResearchList, // 获取研究院列表
  upload: upload, // 上传图片
  liveSub: liveSub,
  fileUpload: fileUpload, // 上传附件
  delFile: delFile, // 发布文章删除附件
  articlesPreserved: articlesPreserved, // 发布文章保存
  articlesSub: articlesSub, // 发布文章提交
  videoUpload: videoUpload, // 视频上传
  getVideoSig: getVideoSig, // 获取云点播签名
  addVideoRecord: addVideoRecord, // 上传视频记录
  delVideoRecord: delVideoRecord, // 删除上传视频
  videoSub: videoSub, // 发布视频提交
  // 首页
  homePage: homePage, // 首页 - 社区生态
  homeEcology: homeEcology, // 首页 - 联盟生态
  homeResearch: homeResearch, // 首页 - 研究院生态
  // 社区生态
  communityIndex: communityIndex, // 社区生态首页
  livelist: livelist, // 最近直播列表
  videolist: videolist, // 精彩回顾列表
  liveMyDetail: liveMyDetail,
  liveDetail: liveDetail, // 直播详情
  signUp: signUp, // 直播预告报名
  userName: userName,
  videoDetails: videoDetails, // 会客厅-视频详情
  getFlowStatsu: getFlowStatsu, // 会客厅-获取推流状态
  communityMembersList: communityMembersList, // 社区交流列表
  communityRecommendMembersList: communityRecommendMembersList, // 社区交流右侧推荐列表
  communityMemberDetails: communityMemberDetails, // 社区交流详情
  activeUserList: activeUserList, // 活跃用户列表
  expertList: expertList, // 专家观点-专家观点列表
  expertDetail: expertDetail, // 专家观点-专家观点详情
  communityVideoList: communityVideoList, // 视频-视频列表
  applyBoard: applyBoard, // 圈子-加入圈子
  retreatBoard: retreatBoard, // 圈子-退出圈子
  dissolutionBoard: dissolutionBoard, // 圈子-解散圈子
  createBoard: createBoard, // 圈子-创建圈子
  eoardEditSub: eoardEditSub, // 圈子-修改圈子
  boardGetMyInfo: boardGetMyInfo, // 圈子列表-用户信息
  boardIndex: boardIndex, // 圈子列表-我的圈子列表
  myJoinBoardList: myJoinBoardList, // 圈子列表-我加入的圈子列表
  getHotBoardList: getHotBoardList, // 圈子列表-热度排序圈子列表
  getNewestBoardList: getNewestBoardList, // 圈子列表-时间排序圈子列表
  getBoardDetails: getBoardDetails, // 圈子帖子列表-获取圈子信息及成员
  boardImageUpload: boardImageUpload, // 圈子帖子列表-发布上传图片
  boardDynamicCreate: boardDynamicCreate, // 圈子帖子列表-发布帖子
  boardPostList: boardPostList, // 圈子帖子列表-获取圈子帖子列表
  boardDoLike: boardDoLike, // 圈子帖子列表-帖子点赞
  boardCancelLike: boardCancelLike, // 圈子帖子列表-帖子取消点赞
  getBoardDynamicDetails: getBoardDynamicDetails, // 圈子帖子详情-获取帖子详情信息
  boardMesSort: boardMesSort, // 圈子帖子详情-圈子评论排序
  boardDynamicMes: boardDynamicMes, // 圈子帖子详情-圈子一级评论
  boardleReplyMes: boardleReplyMes, // 圈子帖子详情-圈子二级评论
  boardTowMesList: boardTowMesList, // 圈子帖子详情-圈子二级评论列表
  BoardMesDoLike: BoardMesDoLike, // 圈子帖子详情-圈子评论点赞
  BoardMesCanceLike: BoardMesCanceLike, // 圈子帖子详情-圈子评论取消点赞
  BoardReport: BoardReport, // 圈子帖子-举报
  boardDynamicDel: boardDynamicDel, // 圈子帖子-删除
  BoardShieldMess: BoardShieldMess, // 圈子帖子详情-圈子评论屏蔽
  BoardDelBoardMes: BoardDelBoardMes, // 圈子帖子详情-圈子评论举报
  BoardReportMes: BoardReportMes, // 圈子帖子详情-圈子评论举报
  // 联盟生态
  getUnionList: getUnionList, // 导航页-导航列表
  applyJoinUnion: applyJoinUnion, // 加入联盟
  unionFramework: unionFramework, // 联盟简介
  getUnionIndex: getUnionIndex, // 联盟首页
  plateRecommendation: plateRecommendation, // 推荐列表
  unionDynamic: unionDynamic, // 动态列表
  getDiscussLiveList: getDiscussLiveList, // 研讨沙龙 - 首页 - 列表
  unionTrainList: unionTrainList, // 培训 - 培训列表
  myTrainList: myTrainList, // 培训 - 我的培训列表
  getTrainDetails: getTrainDetails, // 培训 - 我的培训列表
  getMyContacts: getMyContacts, // 人脉 - 我的人脉
  contactsList: contactsList, // 人脉 - 人脉列表
  totalList: totalList, // 项目路演 - 项目路演列表
  totalRecommendList: totalRecommendList, // 项目路演 - 项目路演推荐列表
  roadshowDetails: roadshowDetails, // 项目路演 - 项目路演详情
  forumDetails: forumDetails, // 论坛 - 论坛详情
  fundDetails: fundDetails, // 基金会 - 基金会详情
  welfareDetails: welfareDetails, // 公益项目 - 公益项目详情
  // 研究院生态
  getResearchList: getResearchList, // 研究院列表
  joinResearch: joinResearch, // 加入研究院
  getResearchFramework: getResearchFramework, // 研究院简介及组织架构
  getResearchIndex: getResearchIndex, // 研究院首页
  getIndexResearchDynamicList: getIndexResearchDynamicList, // 研究院动态
  getWebResearchUserList: getWebResearchUserList, // 研究院成员列表
  getResearchFrameworkUser: getResearchFrameworkUser, // 研究院组织架构成员
  researchTotalList: researchTotalList, // 研究院国际交流/学术甲流/项目合作列表
  researchTotalRecommendList: researchTotalRecommendList, // 研究院学术交流列表
  getResearchFindingsList: getResearchFindingsList, // 研究成果 - 行业手册 - 报告下载 列表
  reportRecommend: reportRecommend, // 研究成果 - 行业手册 - 报告下载 推荐
  reportDetail: reportDetail, // 研究成果 - 行业手册 - 报告下载 详情
  addDownload: addDownload, // 研究成果 - 行业手册 - 报告下载 下载量
  getBookList: getBookList, // 出版物 列表
  getBookDetails: getBookDetails, // 出版物 详情
  getListDetails: getListDetails, // 国际交流 - 学术交流 - 项目合作 详情
  contactInformation: contactInformation, // 研究院首页 - 专家学者
  // 个人中心
  getMyDetails: getMyDetails, // 个人中心 - 个人信息
  getMyDynamic: getMyDynamic, // 个人中心 - 我的动态
  getAboutMeList: getAboutMeList, // 个人中心 - 关于我的
  liveAdminList: liveAdminList, // 个人中心-直播管理列表
  liveAdminOpenLive: liveAdminOpenLive, // 个人中心-直播管理列表-我要开播
  getDiscussPushList: getDiscussPushList, // 个人中心-直播管理列表-我要开播研讨沙龙
  downcast: downcast, // 个人中心-直播管理列表-结束直播
  editVideoExhibition: editVideoExhibition, // 个人中心-直播管理列表-关闭直播回放
  getEditLive: getEditLive, // 个人中心-直播管理列表-直播编辑获取信息
  subEditLive: subEditLive, // 个人中心-直播管理列表-直播编辑提交
  articleAdminList: articleAdminList, // 个人中心-文章管理列表
  articleEdit: articleEdit, // 个人中心-文章管理编辑获取信息
  articleEditSub: articleEditSub, // 个人中心-文章管理编辑提交
  articleDel: articleDel, // 个人中心-文章管理删除
  videoAdminList: videoAdminList, // 个人中心-视频管理列表
  appealVideos: appealVideos, // 个人中心-视频申诉
  videoDetail: videoDetail, // 个人中心-视频详情
  draftAdminList: draftAdminList, // 个人中心-草稿箱管理列表
  draftDetail: draftDetail, // 个人中心-草稿详情
  draftDel: draftDel, // 个人中心-草稿箱管理删除
  getMyfollowList: getMyfollowList, // 个人中心-我的关注
  getMyFansList: getMyFansList, // 个人中心-我的粉丝
  getMyCollectionList: getMyCollectionList, // 个人中心-我的收藏
  getMyMesList: getMyMesList, // 个人中心-我的评论
  userRealNameAuthentication: userRealNameAuthentication, // 个人中心-认证提交接口
  getAuthenticationLog: getAuthenticationLog, // 个人中心-获取认证信息
  editPersonalData: editPersonalData, // 个人中心-修改个人信息
  getUserBindInfo: getUserBindInfo, // 个人中心-账号管理-获取帐号绑定信息
  addAccountName: addAccountName, // 个人中心-账号管理- 修改账号
  editPassword: editPassword, // 个人中心-账号管理-修改密码
  editBindTel: editBindTel, // 个人中心-账号管理-修改手机绑定
  sendEmail: sendEmail, // 个人中心-账号管理-获取邮箱验证码
  checkingEmail: checkingEmail, // 个人中心-账号管理-修改邮箱
  tripartiteInfo: tripartiteInfo, // 个人中心-账号管理-获取第三方账号信息
  bingTripartite: bingTripartite, // 个人中心-账号管理-绑定第三方
  unbundlingTripartite: unbundlingTripartite, // 个人中心-账号管理-解绑第三方
  // 个人中心展示
  getUserDetails: getUserDetails, // 个人中心展示页面 - 信息和其它
  getBloggerDetails: getBloggerDetails, // 个人中心展示页面 - 发表的列表
  // 即使通讯
  getMyFollowMessage: getMyFollowMessage, // 即时通讯-我关注的人的列表
  editReadMsg: editReadMsg, // 即时通讯-设置已读
  getMyToMsgList: getMyToMsgList, // 即时通讯-获取聊天记录
  // 小铃铛
  getInformationReadCount: getInformationReadCount, // 小铃铛未读
  getInformationReadList: getInformationReadList, // 小铃铛列表
  clearInformationRead: clearInformationRead, // 小铃铛清除未读
  // 通用功能
  hotList: hotList, // 热搜列表
  recommendList: recommendList, // 推荐列表
  unreadMessage: unreadMessage, // 头部获取是否有未读消息
  addFollow: addFollow, // 添加关注
  cancelFollow: cancelFollow, // 取消关注
  doLike: doLike, // 点赞功能
  cancelLike: cancelLike, // 取消点赞功能
  doFavorite: doFavorite, // 文章收藏功能
  cancelFavorite: cancelFavorite, // 文章取消收藏功能
  addShare: addShare, // 文章分享次数记录
  oneMes: oneMes, // 一级评论提交
  replyMes: replyMes, // 文章二级评论提交
  mesDoLike: mesDoLike, // 评论点赞
  mesCanceLike: mesCanceLike, // 评论取消点赞
  reportMes: reportMes, // 评论举报
  shieldMes: shieldMes, // 评论屏蔽
  delArticleMes: delArticleMes, // 评论删除
  articleSort: articleSort, // 文章评论查看更多回复
  articleTowMesList: articleTowMesList, // 文章二级评论加载更多回复
  report: report, // 视频、文章举报
  sensitive: sensitive, // 评论、弹幕铭感词汇过滤
  addFeedback: addFeedback, // 问题反馈
  // 全局搜索
  search: search,
  // 手机移动H5
  totalDetailsMobile: totalDetailsMobile, // 手机H5文章详情
  labelRecommendMobile: labelRecommendMobile // 手机H5热门推荐
}

export default myapi
